import { Box, Flex, GovernmentWithFlag, Heading, TCountryCode } from "@govlaunch/web";
import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";
import { IStoryFieldsFragment } from "../fragments/__generated__/StoryFieldsFragment.generated";

interface IStoryGovernmentsProps {
  locations: IStoryFieldsFragment["locations"];
  renderLinkWrap?: (
    government: NonNullable<IStoryFieldsFragment["locations"]>[0],
    children: ReactElement,
  ) => ReactElement;
}
export default function StoryGovernments({ locations, renderLinkWrap }: IStoryGovernmentsProps) {
  return (
    <>
      <Heading as="h3" color="blue.500" fontWeight="bold" fontSize="18" mb={4}>
        <FormattedMessage defaultMessage="Governments" id="qnQX9U" />
      </Heading>
      <div css={{ paddingLeft: 10 }}>
        <Flex wrap="nowrap" mt={3} direction="column">
          {locations &&
            locations.map((location) => {
              const children = (
                <Box key={location._id} mr={3} mb={2}>
                  <GovernmentWithFlag
                    countryCode={location.city.country as TCountryCode}
                    name={location.name}
                    logo={location.logo}
                  />
                </Box>
              );

              return renderLinkWrap
                ? renderLinkWrap(location as NonNullable<IStoryFieldsFragment["locations"]>[0], children)
                : children;
            })}
        </Flex>
      </div>
    </>
  );
}
